import React, { useState, useEffect } from "react";
import { Typography, Box, ListItemIcon, Divider, Avatar, TextField, InputAdornment, Button, Modal, TableContainer, TableBody, Table, TableHead, TableRow, TableCell, Paper, IconButton, Tabs, Tab, TablePagination } from "@mui/material";
import axiosInstance from "../../services/axiosInstance";
import axios from "axios";
import { useOutletContext, } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { profileSectionIcon } from "../../pages/MyProfile/profileSectionIcons";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { apiEndpoint } from "../../urls";
import { dashboard } from "../../store/reducers/pdfeditor/dashboardSlice";
import { color } from "framer-motion";
import { useLogger } from "../../hooks/useLogger";
import CreditAadhaarBar from "./CreditAadhaarBar";
import Loader from "../Loader";

const Credits = () => {
    const MIN_AADHAAR_CREDITS = 1;
    const MIN_DIGITAL_CREDITS = 1;
    const MIN_PAYMENT_AMOUNT = 500;
    const DEFAULT_AADHAAR_CREDITS = 20;
    const DEFAULT_DIGITAL_CREDITS = 20;
    const logEvent = useLogger();
    const dispatch = useDispatch();
    const { open } = useOutletContext();
    const { profileData } = useSelector((state) => state.profile);
    const { data = {}, status } = useSelector((state) => state.dashboard);
    const [allCraditData, setAllCraditData] = useState([]);
    const [addCreditOpen, setAddCreditOpen] = useState(false);
    const [showBulkText, setShowBulkText] = useState(false);
    const [paymentsuccess, setPaymentsuccess] = useState(false);
    const [amountWithGST, setAmountWithGST] = useState(590);
    const [aadhaarCredits, setAadhaarCredits] = useState(DEFAULT_AADHAAR_CREDITS);
    const [digitalCredits, setDigitalCredits] = useState(DEFAULT_DIGITAL_CREDITS);
    const paymentAmountWithoutGST = (Number(aadhaarCredits) || 0) * 20 + (Number(digitalCredits) || 0) * 5;
    const pendingMinimumAmount = Math.max(0, MIN_PAYMENT_AMOUNT - paymentAmountWithoutGST);
    const [tabIndex, setTabIndex] = useState(0);
    const [loader, setLoader] = useState(false);
    const [historyType, setHistoryType] = useState("credit");
    const [historyLoading, setHistoryLoading] = useState(false);
    const [creditHistory, setCreditHistory] = useState([]);
    const [historyPage, setHistoryPage] = useState(1);
    const [historyPageSize, setHistoryPageSize] = useState(10);
    const [historyTotalEntries, setHistoryTotalEntries] = useState(0);

    const selectedEsignType = tabIndex === 0 ? "aadhar" : "digital";

    useEffect(() => {
        // console.log(aadhaarCredits)
        const totalCredits = (aadhaarCredits * 20) + (digitalCredits * 5);
        const gst = (totalCredits * 18) / 100;
        const total = totalCredits + gst;
        setAmountWithGST(total.toFixed(2));
    }, [aadhaarCredits, digitalCredits]);

    const increaseAadhaarCredits = () => {
        logEvent('Clicked', 'Aadhaar Credit increased', 'New-eSign/addCredit');
        setAadhaarCredits(prev => prev + 1);
    };
    
    const decreaseAadhaarCredits = () => {
        logEvent('Clicked', 'Aadhaar Credit decreased', 'New-eSign/addCredit');
        setAadhaarCredits(prev => Math.max(MIN_AADHAAR_CREDITS, Number(prev || MIN_AADHAAR_CREDITS) - 1));
    };
    
    const increaseDigitalCredits = () => {
        logEvent('Clicked', 'Digital Credit increased', 'New-eSign/addCredit');
        setDigitalCredits(prev => prev + 1);
    };
    
    const decreaseDigitalCredits = () => {
        logEvent('Clicked', 'Digital Credit decreased', 'New-eSign/addCredit');
        setDigitalCredits(prev => Math.max(MIN_DIGITAL_CREDITS, Number(prev || MIN_DIGITAL_CREDITS) - 1));
    };

    useEffect(() => {
        if (data.status) {
            setAllCraditData(data.credits || {});
        }
    }, [data]);


    const loadRazorpay = () => {
        if (!document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
          const script = document.createElement('script');
          script.src = 'https://checkout.razorpay.com/v1/checkout.js';
          script.onload = () => {
            // console.log('Razorpay script loaded.');
          };
          script.onerror = () => {
            console.error('Razorpay script could not be loaded.');
          };
          document.body.appendChild(script);
        }
    };
    
    const generateOrderID = async (amount) => {
        try {
            const response = await axiosInstance.post(`/EsignServices/razorpay/order/${amount}`);    
            return response.data; 
        } catch (error) {
            console.error('Order ID Generation Failed:', error.response?.data || error.message);
            return null;
        }
    };
    
    const handlePayment = async () => {
        logEvent('Clicked', 'Pay button clicked', 'Credit');
        // console.log(amountWithGST)
        const orderData = await generateOrderID(amountWithGST * 100);
        // console.log(orderData)
        if (!orderData?.id) {
            alert('Failed to generate Order ID. Please try again.');
            return;
        }
        const options = {
            key: 'rzp_live_fM3BhWsNG9FN5V', // Replace with your Razorpay key ID
            amount: `${amountWithGST * 100}`, // Amount in paisa
            currency: 'INR',
            name: 'Meon Technologies',
            description: 'Transaction For New Esign Recharge',
            image: 'https://meon.co.in/static/meon/img/logo-new.svg',
            order_id: orderData.id,
            handler: function (response) {
                console.log(`Payment Successful! Payment ID: ${response}`, response);
                const creditlog = `${profileData?.company_id} | ${Number(aadhaarCredits?.toString().trim() || 0)} | ${Number(digitalCredits?.toString().trim() || 0)} | ${Number(amountWithGST)} | ${response.razorpay_payment_id}`;
                logEvent('Payment_credit', creditlog, 'Credit');
                checkPayment(response.razorpay_payment_id)
                    .then(response => {
                        console.log(response);
                        if(response?.data?.status===true)
                        {
                            setAddCreditOpen(false);
                            setPaymentsuccess(true);
                        }
                        else {
                            console.log(response)
                        }
                    })
                    .catch(error => console.error(error));
            },
            prefill: {
                name: '',
                email: '',
                contact: '',
            },
            notes: {
                address: '',
            },
            theme: {
                color: '#007bff',
            },
            modal: {
                ondismiss: function () {
                    // alert('Payment failed or was dismissed!');
                },
            },
        };

        if (window.Razorpay) {
            const razorpay = new window.Razorpay(options);
            razorpay.open();
        } else {
            alert('Razorpay SDK failed to load. Please try again.');
        }
    };

    React.useEffect(() => {
        loadRazorpay();
    }, []);
    
    const checkPayment = async (transactionID) => {
        const url = 'https://invoice.meon.co.in/process_esign_with_invoice';
        
        const headers = {
            'Authorization': 'Bearer ssdjhfmbsjdfhvssfeiorfhjvkbercnjsljcf3roujf',
            'Content-Type': 'application/json'
        };
    
        const payload = {
            company_id: profileData?.company_id,
            credits: Number(aadhaarCredits?.toString().trim() || 0),
            digitalCredits: Number(digitalCredits?.toString().trim() || 0),
            razorpay_payment_id: transactionID,
            expected_amount: Number(amountWithGST)
        };
    
        try {
            const response = await axios.post(url, payload, { headers });
            // console.log('Payment Check Response:', response);
            return response;
        } catch (error) {
            console.error('Payment Check Failed:', error.response?.data || error.message);
            return { error: error.response };
        }
    };

    const tabLabels = ['Aadhaar eSign', 'Digital Sign'];
    const handleTabChange = (event, newValue) => {
        logEvent('tabclicked', tabLabels[newValue], 'Documents');
        setTabIndex(newValue);
        setHistoryPage(1);
    };

    const formatDateTime = (value) => {
        if (!value) return "-";
        const parsedDate = new Date(value);
        if (!Number.isNaN(parsedDate.getTime())) {
            const formatted = parsedDate.toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
            return formatted.replace(",", " |");
        }
        return String(value);
    };

    const getHistoryRows = (responseData) => {
        const nestedData = responseData?.data && !Array.isArray(responseData.data) ? responseData.data : null;
        if (Array.isArray(responseData)) return responseData;
        if (Array.isArray(responseData?.data)) return responseData.data;
        if (Array.isArray(responseData?.credit_history)) return responseData.credit_history;
        if (Array.isArray(nestedData?.credit_history)) return nestedData.credit_history;
        if (Array.isArray(responseData?.credit_log)) return responseData.credit_log;
        if (Array.isArray(nestedData?.credit_log)) return nestedData.credit_log;
        if (Array.isArray(responseData?.credit_logs)) return responseData.credit_logs;
        if (Array.isArray(nestedData?.credit_logs)) return nestedData.credit_logs;
        if (Array.isArray(responseData?.logs)) return responseData.logs;
        if (Array.isArray(nestedData?.logs)) return nestedData.logs;
        if (Array.isArray(responseData?.history)) return responseData.history;
        if (Array.isArray(nestedData?.history)) return nestedData.history;
        return [];
    };

    const getHistoryTotalEntries = (responseData, fallbackCount = 0) => {
        const nestedData = responseData?.data && !Array.isArray(responseData.data) ? responseData.data : null;
        const totalValue =
            responseData?.total_entries ??
            responseData?.totalEntries ??
            responseData?.total_count ??
            responseData?.count ??
            responseData?.total ??
            nestedData?.total_entries ??
            nestedData?.totalEntries ??
            nestedData?.total_count ??
            nestedData?.count ??
            nestedData?.total;
        const parsedTotal = Number(totalValue);
        return Number.isFinite(parsedTotal) && parsedTotal >= 0 ? Math.trunc(parsedTotal) : fallbackCount;
    };

    const fetchCreditHistory = async (creditType, esignType, page, pageSize) => {
        try {
            setHistoryLoading(true);
            const getPayload = (esignTypeValue) => ({
                credit_type: creditType,
                esign_type: esignTypeValue,
                page,
                page_size: pageSize,
            });
            const response = await axiosInstance.post("/EsignServices/Getcreditlog", getPayload(esignType));
            let rows = getHistoryRows(response?.data);
            let totalEntries = getHistoryTotalEntries(response?.data, rows.length);

            if (esignType === "aadhar" && rows.length === 0 && totalEntries === 0) {
                const fallbackResponse = await axiosInstance.post("/EsignServices/Getcreditlog", getPayload("aadhaar"));
                rows = getHistoryRows(fallbackResponse?.data);
                totalEntries = getHistoryTotalEntries(fallbackResponse?.data, rows.length);
            }

            setCreditHistory(rows);
            setHistoryTotalEntries(totalEntries);
        } catch (error) {
            console.error("Failed to fetch credit history:", error?.response?.data || error?.message);
            setCreditHistory([]);
            setHistoryTotalEntries(0);
        } finally {
            setHistoryLoading(false);
        }
    };

    const handleHistoryTypeChange = (newHistoryType) => {
        setHistoryType(newHistoryType);
        setHistoryPage(1);
    };

    const handleHistoryPageChange = (event, newPage) => {
        setHistoryPage(newPage + 1);
    };

    const handleHistoryPageSizeChange = (event) => {
        setHistoryPageSize(parseInt(event.target.value, 10));
        setHistoryPage(1);
    };

    useEffect(() => {
        fetchCreditHistory(historyType, selectedEsignType, historyPage, historyPageSize);
    }, [historyType, selectedEsignType, historyPage, historyPageSize]);

    const handleBackToCredits = async () => {
        setLoader(true);
        const result = await dispatch(dashboard());
        const updatedCredits = result?.payload?.credits;
        console.log(result)
        if (updatedCredits) {
            setAllCraditData(updatedCredits);
        }
        setLoader(false);
        setPaymentsuccess(false);
        setAddCreditOpen(false);
    };
    

    return (<>
        <Box sx={{ width: "76%", }}>
            <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                sx={{ 
                    borderBottom: 1, borderColor: "#1D1D1D1A", 
                    "& .MuiTabs-indicator": {
                        height: "4px",
                        backgroundColor: "#185CB7",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px", color: "#185CB7"
                    }, 
                    "& .Mui-selected": 
                    {
                        color: "#185CB7 !important",
                        fontWeight: "500"
                    }
                }}
            >
                <Tab label="Aadhaar eSign" sx={{ textTransform: "none", padding: "20px 30px", fontSize: "16px", fontWeight: 400, color: "#1D1D1D", }} />
                <Tab label="Digital Sign" sx={{ textTransform: "none", padding: "20px 30px", fontSize: "16px", fontWeight: 400, color: "#1D1D1D", }} />
            </Tabs>

            <Box sx={{p: "0 30px 20px 30px", height: "calc(100% - 61px)", overflow: "auto", }}>
                <Box sx={{ p: "27px 30px", textAlign: "left" }}>
                    <Typography sx={{ fontSize: '18px', fontWeight: 600, lineHeight: '20px', color: "#393939", }}>
                        Credits
                    </Typography>
                    <Typography sx={{ fontSize: '16px', fontWeight: 400, lineHeight: '20px', color: "#5C5C5C", mt:"20px" }}>
                        Check your available credits and know more about your credits consumption history.
                    </Typography>
                </Box>
                {tabIndex === 0 && (
                    <CreditAadhaarBar
                        total={allCraditData?.aadhaar_credits?.total_credit_integer ?? 0}
                        available={allCraditData?.aadhaar_credits?.credit_left_integer ?? 0}
                        used={allCraditData?.aadhaar_credits?.credit_used ?? 0}
                        left={allCraditData?.aadhaar_credits?.credit_left_integer ?? 0}
                        setAddCreditOpen={setAddCreditOpen}
                        tabIndex={tabIndex}
                    />
                )}

                {tabIndex === 1 && (
                    <CreditAadhaarBar
                        total={allCraditData?.digital_credits?.total_credit_integer ?? 0}
                        available={allCraditData?.digital_credits?.credit_left_integer ?? 0}
                        used={allCraditData?.digital_credits?.credit_used ?? 0}
                        left={allCraditData?.digital_credits?.credit_left_integer ?? 0}
                        setAddCreditOpen={setAddCreditOpen}
                        tabIndex={tabIndex}
                    />
                )}

                <Box sx={{ mt: "26px" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: "14px" }}>
                        <Typography sx={{ fontSize: "18px", fontWeight: 600, color: "#1D1D1D" }}>
                            Credit Consumption History
                        </Typography>
                        <Box sx={{ display: "flex", background: "#F5F6F8", borderRadius: "10px", p: "3px" }}>
                            <Button
                                onClick={() => handleHistoryTypeChange("credit")}
                                sx={{
                                    minWidth: "120px",
                                    height: "36px",
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    fontSize: "16px",
                                    color: historyType === "credit" ? "#185CB7" : "#1D1D1D",
                                    background: historyType === "credit" ? "#fff" : "transparent",
                                    fontWeight: historyType === "credit" ? 500 : 400,
                                }}
                            >
                                Credit
                            </Button>
                            <Button
                                onClick={() => handleHistoryTypeChange("debit")}
                                sx={{
                                    minWidth: "120px",
                                    height: "36px",
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    fontSize: "16px",
                                    color: historyType === "debit" ? "#185CB7" : "#1D1D1D",
                                    background: historyType === "debit" ? "#fff" : "transparent",
                                    fontWeight: historyType === "debit" ? 600 : 400,
                                }}
                            >
                                Debit
                            </Button>
                        </Box>
                    </Box>

                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: "12px",
                            boxShadow: "none",
                            border: "1px solid #E4E6EB",
                            overflow: "hidden",
                        }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow sx={{ background: "#F5F6F8" }}>
                                    <TableCell sx={{ fontSize: "16px", color: "#1D1D1D", fontWeight: 500, borderBottom: "1px solid #E4E6EB" }}>
                                        Transaction ID
                                    </TableCell>
                                    <TableCell sx={{ fontSize: "16px", color: "#1D1D1D", fontWeight: 500, borderBottom: "1px solid #E4E6EB" }}>
                                        Date & Time
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontSize: "16px", color: "#1D1D1D", fontWeight: 500, borderBottom: "1px solid #E4E6EB" }}>
                                        Amount
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {historyLoading ? (
                                    <TableRow>
                                        <TableCell colSpan={3} sx={{ textAlign: "center", py: 3, color: "#5C5C5C", fontSize: "15px" }}>
                                            Loading history...
                                        </TableCell>
                                    </TableRow>
                                ) : creditHistory.length > 0 ? (
                                    creditHistory.map((row, index) => {
                                        const transactionId = row?.txnid || row?.transaction_id || row?.transactionId || row?.txn_id || row?.id || "-";
                                        const dateTime = row?.date_time || row?.datetime || row?.created_at || row?.created_on || row?.timestamp || "-";
                                        const rawAmount = row?.credit ?? row?.amount ?? row?.credit_amount ?? row?.debit_amount ?? row?.credits ?? 0;
                                        const numericAmount = Number(rawAmount);
                                        const amountValue = Number.isFinite(numericAmount) ? Math.abs(numericAmount) : 0;
                                        const amountText = Number.isInteger(amountValue) ? amountValue.toLocaleString() : amountValue.toFixed(2);
                                        const rowType = String(row?.credit_type || "").toLowerCase();
                                        const isDebitRow = ["deducted", "debit", "used"].includes(rowType);
                                        const amountPrefix = isDebitRow ? "-" : "+";
                                        const amountColor = isDebitRow ? "#EF4949" : "#00B564";

                                        return (
                                            <TableRow key={`${transactionId}-${index}`}>
                                                <TableCell sx={{ fontSize: "15px", color: "#5C5C5C", borderBottom: "1px solid #E4E6EB" }}>
                                                    {transactionId}
                                                </TableCell>
                                                <TableCell sx={{ fontSize: "15px", color: "#5C5C5C", borderBottom: "1px solid #E4E6EB" }}>
                                                    {formatDateTime(dateTime)}
                                                </TableCell>
                                                <TableCell align="right" sx={{ fontSize: "15px", fontWeight: 600, color: amountColor, borderBottom: "1px solid #E4E6EB" }}>
                                                    {`${amountPrefix}${amountText}`}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={3} sx={{ textAlign: "center", py: 3, color: "#5C5C5C", fontSize: "15px" }}>
                                            No {historyType} history found for {selectedEsignType === "digital" ? "Digital Sign" : "Aadhaar eSign"}.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            count={historyTotalEntries}
                            page={Math.max(historyPage - 1, 0)}
                            rowsPerPage={historyPageSize}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            labelRowsPerPage="Page size"
                            onPageChange={handleHistoryPageChange}
                            onRowsPerPageChange={handleHistoryPageSizeChange}
                            sx={{
                                borderTop: "1px solid #E4E6EB",
                                color: "#5C5C5C",
                                "& .MuiTablePagination-toolbar": {
                                    minHeight: "52px",
                                },
                                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                                    fontSize: "14px",
                                },
                            }}
                        />
                    </TableContainer>
                </Box>
            </Box>
        </Box>

        <Modal open={addCreditOpen} onClose={() => setAddCreditOpen(false)}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "652px",
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    overflow: "hidden",
                    borderRadius: "20px",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "27px 30px 25px 30px" }}>
                    <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Add Credits</Typography>
                </Box>
                <Box sx={{ height: 35, backgroundColor: "#FFF5E9", display: "flex", alignItems: "center", gap: 1, padding: "0 12px", borderRadius: "8px", justifyContent: "center" }}>
                    <img src={`${process.env.PUBLIC_URL}/images/credit.png`} alt="Credit" style={{ width: 21, height: 21 }} />
                    <Typography sx={{ fontWeight: 400, fontSize: "16px", color: "#5C5C5C" }}>Available Credits - <span style={{ color: "#1D1D1D" }}>Aadhaar:{allCraditData?.aadhaar_credits?.credit_left_integer || 0} / Digital: {allCraditData?.digital_credits?.credit_left_integer || 0} </span></Typography>
                </Box>

                <Box sx={{ p: "27px 30px 40px 30px", display: "flex", flexDirection: "column", justifyContent: "space-between", }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", height: 64, background: "#FAFAFA", alignItems: "center", p: "0 30px", borderRadius: "10px 10px 0 0", border: "1px solid #D9D9D9" }}>
                        <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#222222", width: 295 }}>Signature Type </Typography>
                        <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                        <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#222222", width: 295, textAlign: "right" }}>Number of Credits</Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", height: 64, background: "#ffffff", alignItems: "center", p: "0 30px", border: "1px solid #D9D9D9", borderTop: "none" }}>
                        <Typography sx={{ fontWeight: 400, fontSize: "16px", color: "#555555", width: 295 }}>Aadhaar eSign </Typography>
                        <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                        <Box sx={{ width: 295, textAlign: "-webkit-right" }}>
                            <Box sx={{ width: 142, height: 30, background: "#EFEFEF", display: "flex", alignItems: "center", padding: "1px", borderRadius: "5px" }}>
                                <IconButton onClick={decreaseAadhaarCredits} size="small" sx={{ background: "#ffffff", borderRadius: "5px 0 0 5px", height: 28, width: 30 }}>
                                    <RemoveIcon />
                                </IconButton>
                                <TextField 
                                    value={aadhaarCredits}
                                    size="small"
                                    type="number"
                                    variant="outlined"
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        "& .MuiOutlinedInput-root": { 
                                            padding: 0,
                                            height: "100%", 
                                            "& fieldset": { border: "none" }
                                        }
                                    }} 
                                     inputProps={{
                                         min: MIN_AADHAAR_CREDITS,
                                         step: 1,
                                         sx: { textAlign: "center", height: "100%", padding: 0 }, 
                                        // readOnly: true 
                                    }} 
                                    onKeyDown={(e) => {
                                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                    }}
                                    onPaste={(e) => {
                                        const paste = e.clipboardData.getData('text');
                                        if (!/^\d+$/.test(paste)) {
                                          e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        const cleanedValue = e.target.value; 
                                        if (cleanedValue === "") {
                                            setAadhaarCredits("");
                                            return;
                                        }
                                        let value = parseInt(cleanedValue);
                                        if (!isNaN(value)) {
                                            if (value >= MIN_AADHAAR_CREDITS && value <= 10000) {
                                              setAadhaarCredits(value);
                                              setShowBulkText(value > 999);
                                            }
                                         }
                                         setShowBulkText(value > 999);
                                         // setAadhaarCredits(Number(value))
                                     }}
                                     onBlur={() => {
                                        if (aadhaarCredits === "" || Number(aadhaarCredits) < MIN_AADHAAR_CREDITS) {
                                            setAadhaarCredits(MIN_AADHAAR_CREDITS);
                                        }
                                     }}
                                 />
                                <IconButton onClick={increaseAadhaarCredits} size="small" sx={{ background: "#ffffff", borderRadius: "0 5px 5px 0", height: 28, width: 30 }}>
                                    <AddIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", height: 64, background: "#ffffff", alignItems: "center", p: "0 30px", border: "1px solid #D9D9D9", borderTop: "none" }}>
                        <Typography sx={{ fontWeight: 400, fontSize: "16px", color: "#555555", width: 295 }}>Digital eSign </Typography>
                        <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                        <Box sx={{ width: 295, textAlign: "-webkit-right" }}>
                            <Box sx={{ width: 142, height: 30, background: "#EFEFEF", display: "flex", alignItems: "center", padding: "1px", borderRadius: "5px" }}>
                                <IconButton onClick={decreaseDigitalCredits} size="small" sx={{ background: "#ffffff", borderRadius: "5px 0 0 5px", height: 28, width: 30 }}>
                                    <RemoveIcon />
                                </IconButton>
                                <TextField 
                                    value={digitalCredits}
                                    type="number"
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        "& .MuiOutlinedInput-root": { 
                                            padding: 0,
                                            height: "100%", 
                                            "& fieldset": { border: "none" }
                                        }
                                    }} 
                                     inputProps={{ 
                                         min: MIN_DIGITAL_CREDITS,
                                         step: 1,
                                         sx: { textAlign: "center", height: "100%", padding: 0 }, 
                                        // readOnly: true 
                                    }}
                                    onKeyDown={(e) => {
                                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                    }}
                                    onPaste={(e) => {
                                        const paste = e.clipboardData.getData('text');
                                        if (!/^\d+$/.test(paste)) {
                                          e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        const cleanedValue = e.target.value; 
                                        if (cleanedValue === "") {
                                            setDigitalCredits("");
                                            return;
                                        }
                                        let value = parseInt(cleanedValue);
                                        if (!isNaN(value)) {
                                            if (value >= MIN_DIGITAL_CREDITS && value <= 10000) {
                                              setDigitalCredits(value);
                                              setShowBulkText(value > 999);
                                            }
                                         }
                                         setShowBulkText(value > 999);
                                         // setDigitalCredits(Number(value))
                                     }}
                                     onBlur={() => {
                                        if (digitalCredits === "" || Number(digitalCredits) < MIN_DIGITAL_CREDITS) {
                                            setDigitalCredits(MIN_DIGITAL_CREDITS);
                                        }
                                     }}
                                 />
                                <IconButton onClick={increaseDigitalCredits} size="small" sx={{ background: "#ffffff", borderRadius: "0 5px 5px 0", height: 28, width: 30 }}>
                                    <AddIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ minHeight: 64, background: "#FFFFFF", alignItems: "center", borderRadius: "0 0 10px 10px", border: "1px solid #D9D9D9", borderTop: "none", }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", p: "0 30px", alignItems: "center", }}>
                            <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#555555", width: 295, p: "15px 0 0 0" }}>Aadhaar * 20 </Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                            <Box sx={{ width: 295, textAlign: "right", p: "15px 0 0 0" }}>
                                <Typography sx={{ fontWeight: 500, fontSize: "18px", color: "#555555" }}>
                                    {(aadhaarCredits * 20).toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", p: "0 30px", alignItems: "center", }}>
                            <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#555555", width: 295, p: 0 }}>Digital * 5 </Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                            <Box sx={{ width: 295, textAlign: "right", p: 0 }}>
                                <Typography sx={{ fontWeight: 500, fontSize: "18px", color: "#555555" }}>
                                    {(digitalCredits * 5).toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", p: "0 30px", alignItems: "center", }}>
                            <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#555555", width: 295, p: "0 0 15px 0" }}>GST (18%) </Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                            <Box sx={{ width: 295, textAlign: "right", p: "0 0 15px 0" }}>
                                <Typography sx={{ fontWeight: 500, fontSize: "18px", color: "#555555" }}>
                                    {((((aadhaarCredits * 20) + (digitalCredits * 5)) * 18) / 100).toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#1D1D1D", width: 295, p: "15px 0 15px 30px", background: "#FAFAFA", borderBottomLeftRadius: "10px" }}>Total Payable Amount </Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                            <Box sx={{ width: 295, textAlign: "right", p: "14px 30px 13px 0", background: "#FAFAFA", borderBottomRightRadius: "10px" }}>
                                <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#1D1D1D" }}>
                                    {amountWithGST}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    
                    {pendingMinimumAmount > 0 && (
                        <Typography sx={{ textAlign: "left", fontWeight: 400, fontSize: "15px", color: "#EF4949", mt: 2 }}>
                            Minimum recharge amount: Rs. {MIN_PAYMENT_AMOUNT}. | Add Rs. {pendingMinimumAmount.toFixed(2)} more to proceed.
                        </Typography>
                    )}
                </Box>
                {showBulkText && (
                    <Typography sx={{ textAlign: "center", fontWeight: 400, fontSize: "15px", color: "#185cb7", pb: 2, minHeight: "39px"}}>For bulk orders, please contact us at sales@meon.co.in"</Typography>
                )}
                <Divider />
                <Box sx={{ p: "15px 30px 17px 30px", display: "flex", flexDirection: "column", justifyContent: "flex-end", }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: "auto", gap: "20px" }}>
                        <Button variant="contained" sx={{ width: '130px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => {setAddCreditOpen(false);}} >
                            Cancel
                        </Button>
                        <Button variant="contained" sx={{ width: '253px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, }} onClick={handlePayment} disabled={paymentAmountWithoutGST < MIN_PAYMENT_AMOUNT}  >
                            Proceed to Make Payment
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
        <Modal open={paymentsuccess}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "652px",
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    overflow: "hidden",
                    borderRadius: "20px",
                }}
            >
                <Box sx={{ p: "46px", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                    <Box sx={{ alignSelf: "center", }}>
                        <img src={`${process.env.PUBLIC_URL}/images/creditSuccess.svg`} alt="success" style={{ height: 132 }} />
                    </Box>
                    <Typography variant="p" sx={{ marginTop: "38px", fontSize: "18px", fontWeight: 600, color: "#1D1D1D", textAlign: "center" }}>Your Credit has been Successfully Added!</Typography>
                    <Typography variant="p" sx={{ marginTop: "22px", fontSize: "16px", fontWeight: 400, color: "#5C5C5C", textAlign: "center" }}>You can now use your newly added credits to complete transaction seamlessly.</Typography>
                    
                    <Box sx={{ display: "flex", justifyContent: "center", mt: "38px",}}>
                        <Button variant="contained" sx={{ width: '253px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", }} onClick={handleBackToCredits}  >
                            Back to Credits
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
        {loader && <Loader />}
        </>
    );
};

export default Credits;
